import React from 'react';
import { AlertTriangle, Loader2, Trash2, X } from 'lucide-react';

export interface ConfirmSheetProps {
  open: boolean;
  title: string;
  children?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  busy?: boolean;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

// Нижняя шторка-подтверждение в стиле редизайна (rf-sheet).
export function ConfirmSheet({
  open,
  title,
  children,
  confirmLabel = 'Удалить',
  cancelLabel = 'Отмена',
  busy = false,
  danger = true,
  onConfirm,
  onCancel,
}: ConfirmSheetProps) {
  if (!open) return null;
  return (
    <div className="rf-sheet-backdrop" onClick={() => { if (!busy) onCancel(); }}>
      <div className="rf-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="rf-sheet-handle" />
        <div className="rf-sheet-head">
          <div className="rf-sheet-title">{title}</div>
          <button className="rf-btn ghost icon" onClick={onCancel} disabled={busy}><X /></button>
        </div>
        <div className="rf-sheet-body">
          <div className="rf-confirm-warn"><AlertTriangle /><div>{children}</div></div>
        </div>
        <div className="rf-sheet-actions">
          <button className={'rf-btn' + (danger ? ' danger' : ' primary')} onClick={onConfirm} disabled={busy}>{busy ? <Loader2 className="spin" /> : <Trash2 />}{confirmLabel}</button>
          <button className="rf-btn" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
        </div>
      </div>
    </div>
  );
}
